import(/* webpackMode: "eager" */ "/vercel/path0/apps/www/.basehub/react-pump/client-pump-U2BHSFPI.js");
;
import(/* webpackMode: "eager", webpackExports: ["Footer"] */ "/vercel/path0/apps/www/src/app/(mkt)/footer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["LightHeader"] */ "/vercel/path0/apps/www/src/components/mkt/header/light.tsx");
